import { isViewingLocalServer, isViewingProdServer } from '../shared/utilities';
import { FormField } from '../types/form';
export { UNSPECIFIED_LABEL } from './labels';

export const ENVIRONMENT = import.meta.env.VITE_CCC_ENVIRONMENT;
// export const ENVIRONMENT: string = 'staging' as const;
// export const ENVIRONMENT: string = 'prod' as const;

// must set to US location if testing cloud functions with remote services
// export const CLOUD_FUNCTION_LOCATION = 'us-central1';
export const CLOUD_FUNCTION_LOCATION = 'europe-west2';

const devStorageConfig = {
  DEV: 'gs://asseticom-dev',
  INTERNAL_RESOURCES: 'gs://asseticom-internal-resources-dev',
  TAXONOMY: 'gs://asseticom-nrm-dev',
  ROOM_SCHEDULE: 'gs://asseticom-room-schedule-dev',
  IMAGE_FLOOR_PLAN: 'gs://asseticom-image-floor-plan-dev',
  IMAGE_ROOM: 'gs://asseticom-image-room-dev',
  IMAGE_ASSET: 'gs://asseticom-image-asset-dev',
  IMAGE_LOGO: 'gs://asseticom-image-logo-dev',
  IMAGE_BACKGROUND: 'gs://asseticom-image-background-dev',
  IMAGE_USER: 'gs://asseticom-image-user-dev',
  DEBUG_INFO: 'gs://asseticom-debug-info-dev',
};

const stagingStorageConfig = {
  DEV: 'gs://asseticom-dev-staging',
  INTERNAL_RESOURCES: 'gs://asseticom-internal-resources-staging',
  TAXONOMY: 'gs://asseticom-nrm-staging',
  ROOM_SCHEDULE: 'gs://asseticom-room-schedule-staging',
  IMAGE_FLOOR_PLAN: 'gs://asseticom-image-floor-plan-staging',
  IMAGE_ROOM: 'gs://asseticom-image-room-staging',
  IMAGE_ASSET: 'gs://asseticom-image-asset-staging',
  IMAGE_LOGO: 'gs://asseticom-image-logo-staging',
  IMAGE_BACKGROUND: 'gs://asseticom-image-background-staging',
  IMAGE_USER: 'gs://asseticom-image-user-staging',
  DEBUG_INFO: 'gs://asseticom-debug-info-staging',
};

const prodStorageConfig = {
  DEV: 'gs://asseticom-dev',
  INTERNAL_RESOURCES: 'gs://asseticom-internal-resources',
  TAXONOMY: 'gs://asseticom-nrm',
  ROOM_SCHEDULE: 'gs://asseticom-room-schedule',
  IMAGE_FLOOR_PLAN: 'gs://asseticom-image-floor-plan',
  IMAGE_ROOM: 'gs://asseticom-image-room',
  IMAGE_ASSET: 'gs://asseticom-image-asset',
  IMAGE_LOGO: 'gs://asseticom-image-logo',
  IMAGE_BACKGROUND: 'gs://asseticom-image-background',
  IMAGE_USER: 'gs://asseticom-image-user',
  DEBUG_INFO: 'gs://asseticom-debug-info',
};

console.log('ENVIRONMENT', ENVIRONMENT);

let storageConfig = stagingStorageConfig;

if (isViewingProdServer() || ENVIRONMENT === 'production') {
  storageConfig = prodStorageConfig;
} else if (isViewingLocalServer() && ENVIRONMENT === 'dev') {
  storageConfig = devStorageConfig;
}

console.log('STORAGE CONFIG', storageConfig);

export const PATHS = {
  STORAGE: storageConfig,
};

export const DRAWER_WIDTH = 240;
export const NOT_APPLICABLE = 'N/A';

export const EXPORT_PREVIEW_COLUMN_ORDER = [
  'Name',
  'Description',
  'Quantity',
  'UOM',
  'Cost',
  'Uplift',
  'Renewal_Multiplier',
  'Renewal_Cost',
  'Remaining_Life',
  'Expected_Life',
  'Reccurs',
];

export const FORMFIELD_DEFAULTS: FormField[] = [
  {
    label: 'Description',
    id: 'Description',
    default: '',
    base: true,
    required: false,
    disabled: false,
    hidden: false,
    type: 'Text',
    nicheFields: [],
    nicheFieldsExcludeMode: true,
  },
  {
    label: 'Quantity',
    id: 'Quantity',
    base: true,
    required: true,
    disabled: false,
    hidden: false,
    type: 'Decimal',
    min: 1,
    default: 1,
    nicheFields: [],
    nicheFieldsExcludeMode: true,
  },
  {
    label: 'Remaining Life',
    id: 'Remaining_Life',
    base: true,
    required: false,
    disabled: false,
    hidden: false,
    type: 'Number',
    nicheFields: [],
    nicheFieldsExcludeMode: true,
  },
];

export const FORM_FIELDS_NAME = 'formFields' as const;
export const FORM_OPTIONS_NAME = 'formOptions' as const;
export const FORM_FIELD_OPTIONS_NAME = 'fieldOptions' as const;

export const SITES_PER_PAGE_DEFAULT = 10;
export const SURVEYS_PER_PAGE_DEFAULT = 10;
export const ROOMS_PER_PAGE_DEFAULT = 10;
export const ASSETS_PER_PAGE_DEFAULT = 20;
export const ASSET_LISTS_PER_PAGE_DEFAULT = 10;
export const LOCAL_IP = '192.168.1.172';
export const CENTRE_ALIGN_HEADER = {
  muiTableHeadCellProps: {
    align: 'center',
  },
};

export const CENTRE_ALIGN_BODY = {
  muiTableBodyCellProps: {
    align: 'center',
  },
};

export const RIGHT_ALIGN_HEADER = {
  muiTableHeadCellProps: {
    align: 'right',
  },
};

export const RIGHT_ALIGN_BODY = {
  muiTableBodyCellProps: {
    align: 'right',
  },
};

export const BIG_ASSET_LIST_NUM_ROWS = 3000;

export const CRISP_CHAT_ID = '082ae3d9-90a9-4875-8365-afa49c71e59d';
export const CRISP_CHAT_ID_STAGING = '11c9209c-46dd-4d6c-81fe-6d30faf37249';

export const NUM_MAX_SURVEY_TAGS = 1;
